import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/footer/components/Contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/footer/components/mail-to.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutWrapper"] */ "/app/components/layout-wrapper/layout-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarWithCategories"] */ "/app/components/navbar/NavbarWithCategories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/app/global-store/cart-data.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
